import React, { useEffect, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { getFileIconByType, MimeType } from "../../common";
import { ProgressCircle } from "../progress-circle";
import { Thumbnail } from "../thumbnail";
import { DocumentRenderMode } from './enums';
import { DocumentContainer, StyledDocumentAndPageContainer, StyledDocumentViewProgressCircleContainer, ThumbContainer } from './style';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
const DEFAULT_SCALE = 1;
const PROGRESS_CIRCLE_SIZE = '4.5rem';
const DEFAULT_TEXT = '';
const renderDocument = (documentId, type) => (React.createElement(ThumbContainer, { id: `thumb-container-${documentId}` },
    React.createElement(Thumbnail, { id: documentId, defaultIcon: getFileIconByType(type), className: "thumnail-inner" })));
const progressCircle = (React.createElement(StyledDocumentViewProgressCircleContainer, null,
    React.createElement(ProgressCircle, { size: PROGRESS_CIRCLE_SIZE })));
export const DocumentView = ({ id, url, type, scale = DEFAULT_SCALE, renderMode = DocumentRenderMode.CANVAS, documentLoadingMessage = DEFAULT_TEXT, pageLoadingMessage = DEFAULT_TEXT, documentNoDataMessage = DEFAULT_TEXT, pageNoDataMessage = DEFAULT_TEXT, documentErrorMessage = DEFAULT_TEXT, pageErrorMessage = DEFAULT_TEXT, shouldDisplaySpinner, shouldRenderAnnotationLayer, onLoadComplete }) => {
    const [zoomScale, setZoomScale] = useState(scale);
    const [isLoading, setIsLoading] = useState(false);
    const [pageInfo, setPageInfo] = useState({ numPages: 0, pagesRendered: 0 });
    const pagesRenderedPlusOne = Math.min(pageInfo.pagesRendered + 1, pageInfo.numPages);
    useEffect(() => {
        setZoomScale(scale);
    }, [scale]);
    useEffect(() => {
        setIsLoading(true);
    }, [url]);
    const handleOnLoadSuccess = pageInfo => {
        setIsLoading(false);
        setPageInfo({ numPages: pageInfo.numPages, pagesRendered: 0 });
        if (onLoadComplete)
            onLoadComplete();
    };
    /* Temporary ignored */
    /*istanbul ignore next*/
    const onRenderSuccess = () => {
        setPageInfo(Object.assign(Object.assign({}, pageInfo), { pagesRendered: pageInfo.pagesRendered + 1 }));
    };
    const renderPDF = () => (React.createElement(DocumentContainer, { id: `document-container-${id}`, isLoading: isLoading, shouldDisplaySpinner: !!shouldDisplaySpinner, className: "document-container" },
        isLoading && shouldDisplaySpinner ? progressCircle : null,
        React.createElement(StyledDocumentAndPageContainer, { isLoading: isLoading, shouldDisplaySpinner: !!shouldDisplaySpinner },
            React.createElement(Document, { id: id, renderMode: renderMode, loading: documentLoadingMessage, noData: documentNoDataMessage, error: documentErrorMessage, file: url, onLoadSuccess: handleOnLoadSuccess, className: "document-pdf" }, Array.from(new Array(pagesRenderedPlusOne), (el, pageIndex) => {
                const needsCallbackToRenderNextPage = pagesRenderedPlusOne === pageIndex + 1 && pageInfo.numPages !== pageIndex + 1;
                return (React.createElement(Page, { key: `page_${pageIndex + 1}`, loading: pageLoadingMessage, noData: pageNoDataMessage, error: pageErrorMessage, scale: zoomScale, pageNumber: pageIndex + 1, className: "document-page", renderAnnotationLayer: !!shouldRenderAnnotationLayer, renderTextLayer: false, onRenderSuccess: needsCallbackToRenderNextPage
                        ? onRenderSuccess
                        : /* Temporary ignored */
                            /*istanbul ignore next*/
                            null }));
            })))));
    return type === MimeType.APPLICATION_PDF ? renderPDF() : renderDocument(id, type);
};
//# sourceMappingURL=DocumentView.js.map